import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { SharedDialogComponent } from '../shared/shared-dialog/shared-dialog.component';
import { SharedErrorDialogComponent } from '../shared/shared-error-dialog/shared-error-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  dialog?: MatDialog;

	openDialog(component: any, data?: any): MatDialogRef<void> | undefined {
		const dialog_config = new MatDialogConfig();
		dialog_config.autoFocus = false;

		if (data != null) {
			dialog_config.data = data;
		}

		return this.dialog?.open(component, dialog_config);
	}

	openInfoDialog(
		message: string,
		title?: string,
		title_icon?: string,
	): MatDialogRef<void> | undefined {
		return this.openDialog(SharedDialogComponent, {
			title: title,
			title_icon: title_icon,
			message: message,
		});
	}

	openErrorDialog(message: string): MatDialogRef<void> | undefined {
		return this.openDialog(SharedErrorDialogComponent, {
			message: message,
		});
	}
}
